module.exports = __webpack_public_path__ + "img/icon-bread-arrow-c947d2b7.svg";